// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"aeda8c16","389":"a4acc865","455":"ef3aa7a2","857":"9c5e8b58","977":"c2961dac"}[chunkId] + ".chunk.js";
};